import { render, staticRenderFns } from "./exception_list.vue?vue&type=template&id=2b14a3e4&scoped=true"
import script from "./exception_list.vue?vue&type=script&lang=js"
export * from "./exception_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14a3e4",
  null
  
)

export default component.exports